import View from "../../View";
import GroupType from "../../enums/GroupType";
import messageResource from "../../messageResource";
import {userHasAssignments} from "./utils";

export default class AssignedUsersEditorContainer extends View {
    constructor({
        assignedUsersEditor,
        $tabTitle,
        tabTitleMessageKey = ""
    }) {
        super();

        this.state = {
            userGroupsEnabled: true,
            timeZoneGroupsEnabled: true,
            users: [],
            userGroups: [],
            timeZoneGroups: [],
            canModifyAny: false,
            assignButtonVisible: false,
        };

        this.assignedUsersEditor = assignedUsersEditor;
        this.$tabTitle = $tabTitle;

        this.onStateChanged(state => {
            this.assignedUsersEditor.setState(state);
            const usersCount = state.users.filter(user => userHasAssignments(user) && user.active).length;
            $tabTitle.text(messageResource.getMessage(tabTitleMessageKey, [usersCount]));
        })
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/usersAssignedToHierarchy/AssignedUsersEditorContainer.js